'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Container = require('./components/Container.NotificationSystem');

var _Container2 = _interopRequireDefault(_Container);

var _Notification = require('./components/Notification.NotificationSystem');

var _Notification2 = _interopRequireDefault(_Notification);

var _notification = require('../../stores/notification.store');

var _notification2 = _interopRequireDefault(_notification);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Store


var NotificationSystem = function (_Component) {
  _inherits(NotificationSystem, _Component);

  function NotificationSystem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationSystem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationSystem.__proto__ || Object.getPrototypeOf(NotificationSystem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notifications: []
    }, _this.onNotifications = function (notifications) {
      return _this.setState({
        notifications: notifications
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationSystem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.unsub = _notification2.default.sub(this.onNotifications);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsub();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          duration = _props.duration,
          pauseOnHover = _props.pauseOnHover;
      var notifications = this.state.notifications;
      return _react2.default.createElement(_Container2.default, null, notifications.map(function (notification) {
        return _react2.default.createElement(_Notification2.default, _extends({
          key: notification.id,
          pauseOnHover: pauseOnHover,
          duration: duration
        }, notification));
      }));
    }
  }]);

  return NotificationSystem;
}(_react.Component);

NotificationSystem.propTypes = {
  duration: _propTypes2.default.number,
  pauseOnHover: _propTypes2.default.bool
};
NotificationSystem.defaultProps = {
  duration: 4000,
  pauseOnHover: false
};
exports.default = NotificationSystem;